import { twMerge } from 'tailwind-merge';

interface NavigationArrowProps {
  direction: 'left' | 'right';
  disabled?: boolean;
  leftArrowClassName?: string;
  rightArrowClassName?: string;
  arrowClassName?: string;
  arrowIconClassName?: string;
  onClick?: () => void;
}

export const NavigationArrow = ({
  direction,
  disabled = false,
  leftArrowClassName = 'left-1',
  rightArrowClassName = 'right-1',
  arrowClassName,
  arrowIconClassName,
  onClick,
}: NavigationArrowProps) => {
  return (
    <div
      className={twMerge(
        'absolute top-1/2 -translate-y-1/2 w-7.5 h-7.5 bg-purple-5433FF rounded-full flex justify-center items-center shadow-xl hover:cursor-pointer',
        direction === 'left' && leftArrowClassName,
        direction === 'right' && rightArrowClassName,
        arrowClassName,
        disabled && 'bg-opacity-85 hover:cursor-not-allowed'
      )}
      onClick={disabled ? () => {} : onClick}
    >
      <i
        className={twMerge(
          `absolute ki-outline ki-${direction} text-white text-[14px]`,
          arrowIconClassName
        )}
      />
    </div>
  );
};
